import { NavLink } from 'react-router'
import { CheckCircleIcon } from '@heroicons/react/20/solid'

const stats = [
  'Running a real club every week for 1+ year',
  'Guests join in 3 clicks',
  '$0 to start',
]

export default function LandingProofBar() {
  return (
    <div className="border-b border-gray-200 bg-gray-50">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-x-8 gap-y-3 px-6 py-5 lg:flex-row lg:justify-center lg:px-8">
        <div className="flex flex-col items-center gap-x-3 gap-y-2 sm:flex-row">
          {stats.map((stat) => (
            <p
              key={stat}
              className="flex items-center gap-x-2 rounded-full bg-white px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-gray-200">
              <CheckCircleIcon
                className="h-4 w-4 flex-none text-indigo-600"
                aria-hidden="true"
              />
              {stat}
            </p>
          ))}
        </div>
        <p className="text-sm text-gray-600">
          Don&apos;t take our word -{' '}
          <NavLink
            to="/clubs"
            className="font-semibold text-indigo-600 hover:text-indigo-500">
            open a real club&apos;s schedule <span aria-hidden="true">→</span>
          </NavLink>
        </p>
      </div>
    </div>
  )
}
